import { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { usePostHog } from 'posthog-js/react';
import { useLocation } from '@tanstack/react-router';

export const PostHogPageView = (): null => {
  const location = useLocation();
  const pathname = location.pathname;
  const posthog = usePostHog();

  // Track pageviews
  useEffect(() => {
    if (pathname && posthog) {
      posthog.capture('$pageview', {
        $current_url: window.origin + pathname,
      });
    }
  }, [pathname, posthog]);

  return null;
};

export const PosthogProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const posthog = usePostHog();
  const { isSignedIn, userId, orgRole, sessionClaims } = useAuth();

  useEffect(() => {
    if (isSignedIn && userId && !posthog._isIdentified()) {
      posthog.identify(userId, {
        role: orgRole,
      });
      posthog.group('company_id', sessionClaims.metadata.companyId);
    }

    //  Reset the user if they sign out
    if (!isSignedIn && posthog._isIdentified()) {
      posthog.reset();
    }
  }, [posthog, isSignedIn, userId, orgRole, sessionClaims]);

  return children;
};
